import { useState } from "react";

export enum DailySettlementSection {
  TOURNAMENT = "TOURNAMENT",
  REVENUE = "REVENUE",
  EXPENSE = "EXPENSE",
  RABBIT = "RABBIT",
  DAILY_SUMMARY = "DAILY_SUMMARY",
}

export enum DailySummaryTab {
  REVENUE = "REVENUE",
  EXPENSE = "EXPENSE",
  BALANCE = "BALANCE",
}

export const useDailySettlementSection = () => {
  const [section, setSection] = useState(DailySettlementSection.TOURNAMENT);
  const [summaryTab, setSummaryTab] = useState(DailySummaryTab.REVENUE);

  const isSection = (tab: DailySettlementSection) => section === tab;
  const isSummaryTab = (tab: DailySummaryTab) => summaryTab === tab;

  return {
    section,
    setSection,
    isSection,
    summaryTab,
    setSummaryTab,
    isSummaryTab,
  };
};
